<div class="title">
  <p-heading [size]="'x-large'" [tag]="'h3'">Education Budget Corrections</p-heading>

  <p-link
    [hideLabel]="(mediaMaxXs$ | async) ?? false"
    [iconSource]="'assets/icons/add.svg'"
    [variant]="'secondary'"
  >
    <a [routerLink]="'/edu-budget-corrections/create'">Create New Education Budget Correction</a>
  </p-link>
</div>

<p-divider aria-hidden="true" />

<section class="list">
  <p-heading
    *ngrxLet="eduBudgetCorrections$ | async as eduBudgetCorrections"
    [size]="'small'"
    [tag]="'h4'"
  >
    {{ eduBudgetCorrections?.totalElements }} Education Budget Corrections
  </p-heading>

  <ng-container
    *ngrxLet="
      eduBudgetCorrections$ as eduBudgetCorrections;
      error as eduBudgetCorrectionsError;
      suspenseTpl: spinner
    "
  >
    <div *ngIf="eduBudgetCorrectionsError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadEduBudgetCorrections()"
      >
        Reload Education Budget Corrections
      </p-button-pure>
    </div>

    <ng-container *ngIf="!eduBudgetCorrectionsError && eduBudgetCorrections">
      <div class="overlay-spinner-host">
        <ng-container *ngIf="loading$ | async" [ngTemplateOutlet]="overlaySpinner" />

        <p-table caption="Education Budget corrections list table">
          <p-table-head>
            <p-table-head-row>
              <p-table-head-cell style="width: 20%">Date</p-table-head-cell>
              <p-table-head-cell style="width: 20%">Person</p-table-head-cell>
              <p-table-head-cell style="width: 20%">Correction Amount</p-table-head-cell>
              <p-table-head-cell style="width: 40%">Description</p-table-head-cell>
            </p-table-head-row>
          </p-table-head>

          <p-table-body>
            <p-table-row
              *ngFor="
                let eduBudgetCorrection of eduBudgetCorrections.content
                  | fillArray: eduBudgetCorrections.pageable.pageSize;
                trackBy: trackRow
              "
            >
              <p-table-cell>
                <ng-container *ngIf="eduBudgetCorrection; else emptyCell">
                  <a [routerLink]="['/edu-budget-corrections', eduBudgetCorrection.id]">
                    {{ eduBudgetCorrection.date | date }}
                  </a>
                </ng-container>
              </p-table-cell>
              <p-table-cell>
                <ng-container *ngIf="eduBudgetCorrection; else emptyCell">
                  <p-text>
                    {{ eduBudgetCorrection.user.firstName }}
                    {{ eduBudgetCorrection.user.lastName }}
                  </p-text>
                </ng-container>
              </p-table-cell>
              <p-table-cell>
                <ng-container *ngIf="eduBudgetCorrection; else emptyCell">
                  {{ eduBudgetCorrection.amount | opaCurrency: null : true }}
                </ng-container>
              </p-table-cell>
              <p-table-cell>
                <ng-container *ngIf="eduBudgetCorrection; else emptyCell">
                  <div class="description-cell">
                    {{ eduBudgetCorrection.description }}
                  </div>
                </ng-container>
              </p-table-cell>
            </p-table-row>
          </p-table-body>
        </p-table>
      </div>

      <p-pagination
        [totalItemsCount]="eduBudgetCorrections.totalElements"
        [itemsPerPage]="eduBudgetCorrections.size"
        [activePage]="eduBudgetCorrections.pageable.pageNumber + 1"
        (update)="updatePageNo($event.detail.page)"
      />
    </ng-container>
  </ng-container>
</section>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>

<ng-template #overlaySpinner>
  <div class="overlay-spinner"><p-spinner /></div>
</ng-template>

<ng-template #emptyCell>
  <span class="empty-cell"></span>
</ng-template>
